import { render, staticRenderFns } from "./consultations-widget.vue?vue&type=template&id=9b9bddae"
import script from "./consultations-widget.vue?vue&type=script&lang=ts"
export * from "./consultations-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports